import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Content } from '../models/content';
import { Portal } from '../models/portal';
import { Player } from '../models/player';
import { VideoPoster } from '../models/videoposter';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import { GlobalService } from './global.service';
import { Subscription } from 'rxjs/Subscription';
//import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/timer';

@Injectable()
export class ApiService {

  private BASE_URL: string;
  
  //private header: Headers;
  //private headerSubscription: Subscription;

  private inactiveTime: number;
  private warningTime: number;
  private inactiveTimerSubscription: Subscription;
  private warningTimerSubscription: Subscription;
  private currentInactiveTime= new BehaviorSubject<Number>(0);
  private currentWarningTime= new BehaviorSubject<Number>(0);
  private showWarningSubject = new BehaviorSubject<Boolean>(false);
  private timeOutSubject = new BehaviorSubject<Boolean>(false);
  
  constructor(private http: HttpClient, private _sanitizer: DomSanitizer, private globals: GlobalService) {
    this.BASE_URL = globals.BASE_URL;
    /*this.headerSubscription = this.globals.getHeader()
    .subscribe(header => {
      this.header = header;
    });*/
  }

  validatePortalURL(content: Content): any{
    let self = this;
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/portalinfo`;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if (res.status == 200) {
            var data = res.body;
            if(data['superUser']){
              content.status = data['status'];
              content.directorID = data['directorID'];
              content.superUser = data['superUser'];
              content.superUsername = data['superUsername'];
              content.clientCode = data['clientCode'];
            } else{
              var por = new Portal(data["portal"].portalID, data["portal"].directorID, data["portal"].name, data["portal"].description, data["portal"].networkID,
                            data["portal"].portalURL, data["portal"].primaryColor, data["portal"].secondaryColor, data["portal"].greeting, 
                            data["portal"].lastModified, data["portal"].updatePending, data["portal"].inactivityTime, data["portal"].warningTime, 
                            data["portal"].allowImport, data["portal"].portalDevices, data["portal"].status, data["portal"].message, 
                            data["portal"].hasGuest, data["portal"].hasUsers, data["portal"].guestID);
              content.portal = por;
              content.status = data['status'];
              content.hasGuest = data['hasGuest'];
              content.hasUsers = data['hasUsers'];
              content.clientCode = data['clientCode'];
              content.directorID = data['directorID'];
              content.superUser = false;
            }
            resolve(content);
          } else{
            reject();
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  validateCommanderPortalURL(content: Content): any{
    let self = this;
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/commanderportalinfo`;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if (res.status == 200) {
            var data = res.body;
            content.status = data['status'];
            content.directorID = data['directorID'];
            content.superUser = data['superUser'];
            content.superUsername = data['superUsername'];
            content.clientCode = data['clientCode'];
            content.noPlayersToAssign = data['noPLayersToAssign'];
            resolve(content);
          } else{
            reject();
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  login(content: Content): any {
    let self = this;
    /*if(this.header == null){
      this.header = new Headers({ 'Content-Type': 'application/json', withCredentials: true });
    }*/
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/login`;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            var data = res.body;
            content.status = data['status'];
            content.message = data['message'];
            content.editorID = data['editorID'];
            resolve(content);
          }
        },
        err => {
          var data = err.error;
          content.status = data.status;
          content.message = data.message;
          content.editorID = data.editorID;
          reject(content);
        });
    });
    return promise;
  }

  guestLogin(content: Content): any{
    let self = this;
    /*if(this.header == null){
      this.header = new Headers({ 'Content-Type': 'application/json', withCredentials: true });
    }*/
    let promise = new Promise((resolve, reject) => {
      let url: string = `${this.BASE_URL}/guestlogin`;
      self.http.post(url, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            var data = res.body;
            content.status = data['status'];
            content.message = data['message'];
            content.editorID = data['editorID'];
            resolve(content);
          }
        },
        err => {
          var data = err.error;
          content.status = data.status;
          content.message = data.message;
          content.editorID = data.editorID;
          reject(content);
        });
    });
    return promise;
  }

  getPlayersForUser(content: Content): any {
    var self = this;
    let promise = new Promise((resolve, reject) => {
      self.http.post(`${this.BASE_URL}/getplayers`, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            var data = res.body;
            var players = [];
            for (var i in data) {
              let pl = new Player(data[i].playerID, data[i].name, data[i].description, data[i].lastModified, data[i].updatePending, data[i].playerProfiles, data[i].serailID, data[i].playerContents, data[i].playerStatus, data[i].supportSuggestion, data[i].extendedSuggestion, data[i].playerLocation, data[i].lastUpdate);
              players.push(pl);
            }
            resolve(players);
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  getVideoPosterShow(posterID: number, content: Content): any{
    var self = this;
    let promise = new Promise((resolve, reject) => {
      self.http.post(`${this.BASE_URL}/getvp/`+posterID, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            var data = res.body;
            let vp = VideoPoster.getVideoPosterFromJSON(data, this._sanitizer);
            resolve(vp);
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  submit(content: Content): any{
    var self = this;
    let promise = new Promise((resolve, reject) => {
      self.http.post(`${this.BASE_URL}/save`, content, { observe: 'response', responseType: 'json' })
        .toPromise()
        .then(
        (res) => {
          if(res.status == 200){
            var data = res.body;
            content.submissionID = data['submissionID'];
            resolve(content);
          }
        },
        err => {
          reject(err);
        });
    });
    return promise;
  }

  setTime(inactiveTime, warningTime): void{
    /*this.inactiveTime = inactiveTime;
    this.warningTime = warningTime;
    this.killTimer();
    this.startTimer();
    console.log("session reset");*/
  }

  startTimer(){
    /*const source = Observable.interval(1000);
    const timer = Observable.timer(this.inactiveTime * 1000 + 1000);
    const example = source.takeUntil(timer);
    
    var self = this;
    this.inactiveTimerSubscription = example.subscribe(val => {
      self.currentInactiveTime.next(self.inactiveTime - val);
      if(val == self.inactiveTime-1){
        self.showWarningSubject.next(true);
        const source1 = Observable.interval(1000);
        const timer1 = Observable.timer(self.warningTime * 1000 + 1000);
        const example1 = source1.takeUntil(timer1);
        if(self.warningTimerSubscription){
          self.warningTimerSubscription.unsubscribe();
        }
        self.warningTimerSubscription = example1.subscribe(wval => {
          self.currentWarningTime.next(self.warningTime - wval);
          if(wval == self.warningTime - 1){
            this.timeOutSubject.next(true);
          }
        })
      }
    });*/
  }

  getShowWarning(): Observable<Boolean>{
    return this.showWarningSubject.asObservable();
  }

  getTimeOut(): Observable<Boolean>{
    return this.timeOutSubject.asObservable();
  }

  killTimer(): void{
    /*if(this.inactiveTimerSubscription){
      this.inactiveTimerSubscription.unsubscribe();
    }
    if(this.warningTimerSubscription){
      this.warningTimerSubscription.unsubscribe();
    }
    this.showWarningSubject.next(false);
    this.timeOutSubject.next(false);*/
  }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts